import script from "./ModalPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalPopup.vue?vue&type=script&setup=true&lang=js"

import "./ModalPopup.vue?vue&type=style&index=0&id=777083ea&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-777083ea"]])

export default __exports__